module.exports = __webpack_public_path__ + "static/media/get-free-delivery.b3f3e3e7.png";